<div class="app__solid--border w-[750px] h-[600px] relative rounded-xl bg-white border-[#e2e4e5]">
  <div class="flex justify-between" style="padding: 32px 24px 0px">
    <span class="relative text-center m-0" style="width: -webkit-fill-available">
      <span class="block">
        <p class="app__form--attribute--title text-2xl leading-9 text-center">Manage Members</p>
        <p class="app__form--attribute--title font-normal text-sm text-[#515765] text-center mt-[-10px]">
          Manage members of {{ data.vaultName }}
          {{ data.vaultType == 'shared' ? 'Shared' : data.vaultType == 'entity' ? 'Entity' : 'Personal' }} vault
        </p>
      </span>
    </span>
    <button class="close" type="button" data-dismiss="modal" (click)="closeDialog()">
      <span class="material-icons relative text-[30px] text-[#707070] font-semibold leading-9">close </span>
    </button>
  </div>

  <div style="padding: 0px 52px">
    <div>
      <vault-setup-members
        [userObject]="userObject"
        [stateObject]="stateObject"
        [make_owner_enabled]="make_owner_enabled"
        [isFromManageVault]="true"
        [vaultName]="data.vaultName"
        [isFromVault]="false"
      ></vault-setup-members>
    </div>
  </div>
</div>
